import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import DracmaPurchase from './DracmaPurchase'; // Reutilizando o componente existente
import styles from './Profile.module.css'; // Importar estilos

const BillingSection = ({ activeSubTab, setActiveSubTab, balance, usageHistory, paymentHistory, refreshHistories, user }) => {
  const { t } = useTranslation();

  // Lógica para formatar datas e valores, se necessário
  const formatTimestamp = (timestamp) => {
    const date = new Date(timestamp * 1000); // Multiplicar por 1000 para converter segundos para milissegundos
    return date.toLocaleString(); // Formato de data e hora local
  };

  return (
    <div className="profile-section"> {/* Usa a classe de card principal */}
      <h3 className={styles['tab-section-title']}>{t('billingInformation')}</h3>

      <div className={styles.subTabContainer}>
        <button
          className={activeSubTab === 'balance' ? styles.activeSubTab : ''}
          onClick={() => setActiveSubTab('balance')}
        >
          {t('dracmaBalance')}
        </button>
        <button
          className={activeSubTab === 'usage' ? styles.activeSubTab : ''}
          onClick={() => setActiveSubTab('usage')}
        >
          {t('usageHistory')}
        </button>
        <button
          className={activeSubTab === 'payment' ? styles.activeSubTab : ''}
          onClick={() => setActiveSubTab('payment')}
        >
          {t('paymentHistory')}
        </button>
        <button
          className={activeSubTab === 'purchase' ? styles.activeSubTab : ''}
          onClick={() => setActiveSubTab('purchase')}
        >
          {t('buyDracmas')}
        </button>
      </div>

      {activeSubTab === 'balance' && (
        <div className={styles['balance-section']}>
          <p className={styles['balance-label']}>{t('currentBalance')}</p>
          <p className={styles.balance}>{balance !== null ? balance : t('loading')} 𝑫𝑷</p>
          {/* Adicionar ícone de informação se desejar */}
        </div>
      )}

      {activeSubTab === 'usage' && (
        <div>
          <div className={styles['billing-history-header']}>
            <h4>{t('usageHistory')}</h4>
            <button onClick={refreshHistories} className={styles.refreshButton}>{t('refresh')}</button>
          </div>
          {usageHistory.length > 0 ? (
            <table className={styles.historyTable}>
              <thead>
                <tr>
                  <th>{t('date')}</th>
                  <th>{t('service')}</th>
                  <th>{t('dracmasUsed')}</th>
                </tr>
              </thead>
              <tbody>
                {usageHistory.map((item, index) => (
                  <tr key={index}>
                    <td>{formatTimestamp(item.timestamp)}</td>
                    <td>{item.service_type}</td>
                    <td>{item.dracmas_spent} 𝑫𝑷</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p className={styles.noHistoryMessage}>{t('noUsageHistory')}</p>
          )}
        </div>
      )}

      {activeSubTab === 'payment' && (
        <div>
          <div className={styles['billing-history-header']}>
            <h4>{t('paymentHistory')}</h4>
            <button onClick={refreshHistories} className={styles.refreshButton}>{t('refresh')}</button>
          </div>
          {paymentHistory.length > 0 ? (
            <table className={styles.historyTable}>
              <thead>
                <tr>
                  <th>{t('date')}</th>
                  <th>{t('amount')}</th>
                  <th>{t('dracmasReceived')}</th>
                  <th>{t('status')}</th>
                </tr>
              </thead>
              <tbody>
                {paymentHistory.map((item, index) => (
                  <tr key={index}>
                    <td>{formatTimestamp(item.timestamp)}</td>
                    <td>{item.amount}</td>
                    <td>{item.dracmas_received} 𝑫𝑷</td>
                    <td>{item.status}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <p className={styles.noHistoryMessage}>{t('noPaymentHistory')}</p>
          )}
        </div>
      )}

      {activeSubTab === 'purchase' && <DracmaPurchase />}
    </div>
  );
};

export default BillingSection;
